import React from 'react';

/** Five-star rating display. Decorative stars are hidden from screen readers. */
const Rating = ({ value = 0, className = '' }) => {
  const rounded = Math.round(Number(value) || 0);

  return (
    <div
      className={`ij-card__rating ${className}`.trim()}
      role="img"
      aria-label={`Rated ${rounded} out of 5`}
    >
      {Array.from({ length: 5 }, (_, index) => (
        <span
          key={index}
          aria-hidden="true"
          className={index < rounded ? '' : 'ij-card__rating--empty'}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default Rating;
